import type React from 'react'
import type { JSX } from 'react'

export interface ILinkProps extends Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  'href'
> {
  href?: string
  children: React.ReactNode
  isOpened?: boolean
  color?: string
}

export const Link = ({
  href,
  children,
  isOpened: _isOpened,
  color: _color,
  ...props
}: ILinkProps): JSX.Element => {
  // If no href is provided, render children as-is
  if (!href) return <>{children}</>

  const internal = !href.startsWith('http')

  // External link
  if (!internal) {
    return (
      <a
        href={href}
        target={props.target ?? '_blank'}
        rel={props.rel ?? 'noreferrer'}
        {...props}
      >
        {children}
      </a>
    )
  }

  // Internal application link
  return (
    <a href={href} {...props}>
      {children}
    </a>
  )
}
